import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  useHotelAvailabilitySearch,
  useHotelsAvailabilityFilters,
} from "@tenant/hotels";
import { DateRangePicker } from "@tenant/hotels";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelListNoHotels.module.scss";
import HotelBedIllustration from "@/assets/images/hotel-bed.svg?react";

export const HotelListNoHotels = ({ className }: PlatformComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListNoHotels;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { handlers, context } = useHotelsAvailabilityFilters();
  const { context: availabilityContext, handlers: availabilityHandlers } =
    useHotelAvailabilitySearch();

  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)} role="status">
      <HotelBedIllustration aria-hidden="true" />
      <h2 className={cn("title")}>
        {t("core-hotels.availabilityPage.results.noResults.noHotelsFound")}
      </h2>
      <p className={cn("subtitle")}>
        {t("core-hotels.availabilityPage.results.noResults.noHotelsAvailable")}
      </p>
      <div className={cn("actions")}>
        <DateRangePicker
          startDate={availabilityContext.dateRange?.from}
          endDate={availabilityContext.dateRange?.until}
          onStartDateChangeHandler={
            availabilityHandlers.handleDateRangeFromChange
          }
          onEndDateChangeHandler={
            availabilityHandlers.handleDateRangeUntilChange
          }
          onClose={() => availabilityHandlers.handleDateRangeClose(true)}
          triggerButton={
            <Button
              className={cn("change-dates-button")}
              buttonType={ButtonTypeEnum.Primary}
            >
              {t("core-hotels.availabilityPage.results.noResults.changeDates")}
            </Button>
          }
        />

        {context.hasFilters && (
          <Button
            className={cn("reset-filters-button")}
            buttonType={ButtonTypeEnum.Primary}
            onClick={handlers.resetFilters}
          >
            {t("core-hotels.availabilityPage.filters.resetFilters")}
          </Button>
        )}
      </div>
    </div>
  );
};
